import { Injectable, Input } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, delay, map, retryWhen, take, tap, timeout } from 'rxjs/operators';
import { GEOSERVER_URL, GEE_IMAGE_API_BASEURL, environment, API_BIO_URL } from 'src/environments/environment';
import * as _ from 'underscore';
import * as turf from '@turf/turf';
import { FeatureCollection, Geometry, Polygon } from 'geojson';
import { Alert } from '../../entities/alert.entity';
import { AlertsVisualizationFilter } from '../../interfaces/alerts-visualization-filter.interface';
import { formatVisualizationFilterPayload } from '../../utils/format-filter-params';
import { ALERT_VALIDATION_LAYER, GEOSERVER_WORKSPACE } from '../../constants';
import { GetAlertGeeImagesProcessedParams, AlertGeeImageProcessed, GEOSERVER_LAYER_ALERTS_REFINED, UpdateAlertGeeImageProcessed, GeeImageProcessed, AlertValidationGeeImage } from '../../types';
import { Observable, firstValueFrom, of } from 'rxjs';
import API_URL from '../../utils/api-url-homolog';

const ajax = {
  post: (url: string, params: any) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        method: "POST",
        url: url,
        contentType: 'application/x-www-form-urlencoded; charset=utf-8',
        timeout: 20000,
        error: () => reject,
        data: params,
        dataType: 'json',
      }).done((response: any) => resolve(response))
        .fail((jqXHR: any, textStatus: any, errorThrown: any) => {
          reject(textStatus);
        })
    });
  }
}

@Injectable({
  providedIn: 'root'
})
export class AlertVisualizationService {
  // getDataForModelAndScenario: any;
  // private API_URL = environment.API_URL;
  // formatVisualizationFilterPayload: any;
  @Input() filter: AlertsVisualizationFilter;
  getTerritoryName: any;
  getCityName: any;
  constructor(private http: HttpClient) { }

  /**
   * Gets alerts
   */
  getAlerts(): Promise<Alert[]> {
    return this.http.get<Alert[]>(`${API_URL}/alert/list`).toPromise();
  }

  /**
   * Gets alert by id
   */
  async getAlertById(id: number, layer: string): Promise<Alert> {
    return this.http.post<Alert[]>(`${API_URL}/alert/map/metadatabyid`, {
      layerType: layer,
      alertId: id
    }).pipe(
      map(response => Object.assign(new Alert(), response[0]))
    ).toPromise()
  }

  /**
   * Get alert pdf data
   */
  async getAlertPdfData(alertId: number): Promise<any> {
    return this.http.get<any>(`${API_URL}/alert/pdf/${alertId}`).toPromise();
  }

  async getShapefile(alertId: number) {
    // console.log('alertId', alertId)
    return this.http.get<any>(
      `${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/wfs?` +
      `service=WFS&` +
      `version=1.1.0&` +
      `request=GetFeature&` +
      `typeName=SIGALERTA:GEOSERVER_ALERT_REFINED&` +
      `propertyName=ALERT_ID,GEOM&` +
      `outputFormat=SHAPE-ZIP&` +
      `cql_filter=ALERT_ID=${alertId}&` +
      `srsName=EPSG:4326`
    );
  }

   //Faz uma chamada POST para uma API para obter estatísticas de território com base em um filtro.
  /**
   * Get Table Ranking de especies
  */
   getEspecies(territoryID: string,CityID:string ): Observable<any> {
    return this.http.get<any>(`${API_BIO_URL}/table/especies/${territoryID}/${CityID}`);
  }

   /**
   * Get municipio
  */
  getCity( territoryID: string,CityID:string): Observable<any> {
    return this.http.get<any>(`${API_BIO_URL}/${territoryID}/${CityID}`);
  }
  
 /**
   * Get Metadados
  */
   getMetadata(territoryID: string,CityID:string ): Observable<any> {
    
    return this.http.get<any>(`${API_BIO_URL}/metadata/${territoryID}/${CityID}`);
  }

    /**
   * Get indicators Biodiversidade (Uso e cobertura da terra)
  */
    async getBiodiversity(territoryID: string,CityID:string ): Promise<any> {
      return this.http.get<any>(`${API_BIO_URL}/table/biodiversidade/${territoryID}/${CityID}`).toPromise();
    }

  /**
   * Get Chart 1 Tendência de Temperatura da Superficie
   */
   getTasStatsURL(territoryID: string, cityID: string, model: string, scenario: string) {
    return `${API_BIO_URL}/graph/tas/${territoryID}/${cityID}/${model}/${scenario}`;
  }

  /**
   * Get Chart 2 Tendência da Chuva Média Anual
  */
 getPrecipitationStatsURL(territoryID: string, cityID: string, model: string, scenario: string): string {
   return `${API_BIO_URL}/graph/pre/${territoryID}/${cityID}/${model}/${scenario}`;
  }

  /**
   * Get Chart 3 Carbono
  */
    getCarbonoURL(territoryID: string, cityID: string) {
   return `${API_BIO_URL}/graph/carbono/${territoryID}/${cityID}`;
  }

  /**
   * Get Chart 4 - POSIÇÃO 1 - Indicadores (Uso e cobertura da terra)
  */
  async getStatsAreaBlocks(territoryID: string,CityID:string ): Promise<any> {
   return this.http.get<any>(`${API_BIO_URL}/area/${territoryID}/${CityID}`).toPromise();
 }

 /**
   * Get Chart 5 Valor Ecossistemico https://bfkts3jaswinpvxy12014.cleavr.one/api/graph/valorecossistemico/municipios/1 
  */
 getEcosystemValue(territoryID: string, cityID: string): string {
  return `${API_BIO_URL}/graph/valorecossistemico/${territoryID}/${cityID}`;
 }

 /**
  * Get chart 6 AGUA
 */
  getWaterURL(territoryID: string, cityID: string ): string {
    return `${API_BIO_URL}/graph/agua/${territoryID}/${cityID}`;
  }
 /**
  * Get chart 7 NPP
 */
  getDNppHistogramURL(territoryID: string, cityID: string ): string {
    return `${API_BIO_URL}/graph/npp/${territoryID}/${cityID}`;
  }



  /**
   * Get wfss alert by coord
   *
   */

  async getWFSAlertByLatLng(latLng: L.LatLng, buffer: number = 0.2, layer: string, cqlFilter = ''): Promise<FeatureCollection> {

    const pointBuffer = turf.buffer(turf.point([latLng.lng, latLng.lat]), buffer, { units: 'kilometers' });


    const payload = {
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName: layer,
      maxFeatures: '5',
      outputFormat: 'application/json',
      CQL_FILTER: `${cqlFilter != '' ? ('(' + cqlFilter + ') AND ') : ''} INTERSECTS("GEOM",POLYGON((${pointBuffer.geometry.coordinates[0].map(c => c[0] + ' ' + c[1]).join(', ')}))) ${(layer == (ALERT_VALIDATION_LAYER) ? 'AND ALERT_DELETED_AT is null' : '')}`,
    };

    const httpParams = new HttpParams({
      fromObject: payload
    });

    const featuresCol = await this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();

    if (featuresCol.features.length > 0) {
      featuresCol.features.sort((itemA, itemB) => {
        let distanceA = turf.distance(turf.center(itemA as any), turf.point([latLng.lng, latLng.lat]), { units: 'kilometers' });
        let distanceB = turf.distance(turf.center(itemB as any), turf.point([latLng.lng, latLng.lat]), { units: 'kilometers' });
        let sort = 1;
        if (distanceA < distanceB) {
          sort = 1;
        } else {
          sort = -1;
        }
        if (distanceA == distanceB) {
          sort = 0;
        }
        return sort;
      });
      featuresCol.features = [featuresCol.features[0]];
    }
    return featuresCol;
  }

  /**
   * Gets wfss alert by Polygon
   */
  async getWFSAlertByPolygon(polygon: Polygon, layer: string, cqlFilter = ''): Promise<FeatureCollection> {

    const payload = {
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName: layer,
      outputFormat: 'application/json',
      // CQL_FILTER: `INTERSECTS("GEOM",POLYGON((${polygon.coordinates[0].map(c => c[0] + ' ' + c[1]).join(', ')})))`,
      CQL_FILTER: `${cqlFilter != '' ? ('('+cqlFilter+') AND '):''} INTERSECTS("GEOM",POLYGON((${polygon.coordinates[0].map(c => c[0] + ' ' + c[1]).join(', ')}))) AND ALERT_DELETED_AT is null`
    };

    const httpParams = new HttpParams({
      fromObject: payload
    });

    const featuresCol = await this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();


    return featuresCol;
  }

  /**
   * Gets wfss alert by coord
   */
  // // getWFSAlertById(id: number, layer: string): Promise<FeatureCollection> {

  // //   const payload = {
  // //     service: 'WFS',
  // //     version: '1.0.0',
  // //     request: 'GetFeature',
  // //     typeName: layer,
  // //     //maxFeatures: '10',
  // //     outputFormat: 'application/json',
  // //     CQL_FILTER: `"ID" = ${id}`,
  // //   };

  // //   const httpParams = new HttpParams({
  // //     fromObject: payload
  // //   });

  // //   return this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();
  // // }

  // /**
  //  * Gets wfss alert by coord
  //  */
  // // getWFSCityById(id: number): Promise<FeatureCollection> {
  // //   const payload = {
  // //     service: 'WFS',
  // //     version: '1.0.0',
  // //     request: 'GetFeature',
  // //     typeName: `${GEOSERVER_WORKSPACE}:GEO_MUNICIPIO`,
  // //     //maxFeatures: '10',
  // //     outputFormat: 'application/json',
  // //     CQL_FILTER: `"ID" = ${id}`,
  // //   };

  // //   const httpParams = new HttpParams({
  // //     // fromObject: filterPayload as { [key: string]: string } //todos os valores em filterPayload podem ser convertidos para strings
  // //     fromObject: payload
  // //   });

  // //   return this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();
  // // }

  // // getWFSTerritoryById(id: number, layer: string): Promise<FeatureCollection> {
  // //   const payload = {
  // //     service: 'WFS',
  // //     version: '1.0.0',
  // //     request: 'GetFeature',
  // //     typeName: `${GEOSERVER_WORKSPACE}:${layer}`,
  // //     //maxFeatures: '10',
  // //     outputFormat: 'application/json',
  // //     CQL_FILTER: `"ID" = ${id}`,
  // //   };

  // //   const httpParams = new HttpParams({
  // //     fromObject: payload
  // //   });

  // //   return this.http.get<FeatureCollection>(`${GEOSERVER_URL}/${GEOSERVER_WORKSPACE}/ows`, { params: httpParams }).toPromise();
  // // }

  getAlertGeeImages(params: GetAlertGeeImagesProcessedParams): Observable<AlertGeeImageProcessed> {
    const payload = {
      alert_id: params.alertId,
      alert_geometry_id: params.alertGeometryId,
      date_detection: params.dateDetection,
      polygon: params.polygon,
      draw: 'true',
    };

    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      timeout: 600000, // Tempo limite em milissegundos (neste exemplo, 60 segundos)
    };

    return this.http.post<AlertGeeImageProcessed>(`${GEE_IMAGE_API_BASEURL}/createPNG`, payload, requestOptions);
  }

  getPNGFromImage(params: any): Observable<GeeImageProcessed> {
    const payload = {
      alert_id: params.alertId,
      alert_geometry_id: params.alertGeometryId,
      date_detection: params.date,
      image: params.name,
      polygon: params.polygon,
      contrast: params.contrast,
      brightness: params.brightness,
      gamma: params.gamma,
      draw: "true"
    };

    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      timeout: 600000, // Tempo limite em milissegundos (neste exemplo, 60 segundos)
    };

    return this.http.post<GeeImageProcessed>(`${GEE_IMAGE_API_BASEURL}/createPNGfromImage`, payload, requestOptions)
  }

  getPNGFromThumb(params: any): Promise<any> {
    const payload = {
      image: params.name,
      polygon: params.polygon,
      satellite: params.satellite,
      cloudCoverage: params.cloudCoverage,
      bands: params.bands,
      alertId: params.alertId,
      alertGeometryId: params.alertGeometryId,
      draw: params.draw,
      contrast: params.contrast,
      brightness: params.brightness,
      gamma: params.gamma
    };

    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
      }),
      timeout: 600000, // Tempo limite em milissegundos (neste exemplo, 60 segundos)
    };

    // return firstValueFrom(this.http.post<AlertValidationGeeImage>(`${GEE_IMAGE_API_BASEURL}/getThumb2`, payload, requestOptions))
    return ajax.post(`${GEE_IMAGE_API_BASEURL}/getThumb2`, params)
  }

  getAlertImages(params: {
    polygon: string,
    dateBefore: string,
    date: string,
    tempo: string,
    satellite: string,
    draw:boolean,
    bands: string,
    cloudCoverage: number
  }) {

    const alertValidationImages = new Observable<AlertValidationGeeImage[]>((subscriber) => {
      ajax.post(`${GEE_IMAGE_API_BASEURL}/getImageList`, params)
        .then((result: any) => {
          const images: AlertValidationGeeImage[] = result.map((imgIds: any) => {
            return {
              imgID: imgIds,
              draw: false
            };
          });
          subscriber.next(images);
          return { result, images };
        })
      }
    ).pipe(
      retryWhen(errors => errors.pipe(delay(2000), take(10)))
    );
    return firstValueFrom(alertValidationImages);
  }

  async updateAlertGeeImages(params: UpdateAlertGeeImageProcessed) {
    return this.http.post<any>(`${API_URL}/alert/validation/map/updateimg`, params)
      .pipe(map(response => response[0]))
      .toPromise();
  }
}
